export default __webpack_public_path__ + "static/mobile_section3_feature3-70656c7303515430ed7ca46af8f14477.png";